import styled, { css } from 'styled-components';

const UpCaret = css`
  transform: rotate(-135deg);
  margin: 0 0 -1px 5px;
`;

const DownCaret = css`
  transform: rotate(45deg);
  margin: 0 0 3px 5px;
`;

const Caret = styled.span`
  border: solid ${props => props.theme.carvana[props.color || 'blue']};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;

  ${props => props.isOpen && UpCaret};
  ${props => !props.isOpen && DownCaret};
`;

export default Caret;
